export const DefaultInit = { cachetoken: "", threedinit: "" };
